import React from 'react';
import classnames from 'classnames';
import { Icon } from '../icon';
import styles from './input-message.module.scss';

const baseClass = 'input-message';

export type InputMessageProps = {
  isError?: boolean;
  id: string;
  message: string;
  disabled?: boolean;
} & Pick<React.HTMLAttributes<HTMLElement>, 'className'>;

export const InputMessage: React.FC<InputMessageProps> = ({ message, id, className, isError, disabled }) => {
  const variant = isError ? 'error--medium' : 'info-legal--medium';
  const classes = classnames(
    styles['input-message'],
    styles[`${baseClass}--${variant}`],
    {
      [styles[`${baseClass}--disabled`]]: disabled
    },
    className
  );

  return (
    <div className={classes} id={id}>
      {isError && (
        <div className={styles.iconWrapper}>
          <Icon className={styles[`${baseClass}__icon`]} name="warning--medium" />
        </div>
      )}
      {message}
    </div>
  );
};
